import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

//Carousel
import Carousel from "react-bootstrap/Carousel";

//logo
import logo1 from "./assete/hararti/logo1.png";
import logo2 from "./assete/hararti/logo2.png";
import logo3 from "./assete/hararti/logo3.png";
import logo4 from "./assete/hararti/logo4.png";
//photo

import pic1 from "./assete/hararti/pic1.png";
import pic2 from "./assete/hararti/pic2.png";
import pic3 from "./assete/hararti/pic3.png";

const Hararati = () => {
  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <Box
            component="div"
            className="logo"
            sx={{
              display: "flex",

              justifyContent: "space-around",
              margin: "20px 0px",
            }}
          >
            <img src={logo1} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo2} alt="Logo" style={{ width: "15%" }}></img>
            <img src={logo3} alt="Logo" style={{ width: "12%" }}></img>
            <img src={logo4} alt="Logo" style={{ width: "12%" }}></img>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" className="text" sx={{ marginTop: "20px" }}>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              سیستم کنترل ، مانیتورینگ و گزارش گیری کوره های عملیات حرارتی
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>شرکت آهنگری تراکتور سازی</li>
              <li>شرکت طراحی و تولید قطعات آهنگری ایران خودرو</li>
              <li>شرکت فورج البرز</li>
              <li>شرکت آذر فلز</li>
            </ul>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6} sx={{ marginTop: "20px" }}>
          <Box component="div">
            <Carousel style={{ width: "100%", float: "left" }}>
              <Carousel.Item>
                <img src={pic1} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic2} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic3} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
            </Carousel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default Hararati;
